import {
  FormikAccidentData,
  FormikDraftCAI,
  FormikVehicle,
  Optional,
  VehicleType,
} from "src/types";
import { createJSONStorage, persist } from "zustand/middleware";
import { defaultDraftCAIFormikValues } from "./formik-default-values";
import { create } from "zustand";

const STORAGE_KEY_DRAFT_CAI = "draftCAI";
interface DraftCAIState {
  draft: FormikDraftCAI;

  setDraft: (draft: FormikDraftCAI) => void;
  setVehcileAPlate: (plate: string) => void;
  updateVehicleDraft: ({
    vehicleType,
    vehicleDraft,
  }: {
    vehicleType: VehicleType;
    vehicleDraft: FormikVehicle;
  }) => void;
  updateAccidentDataDraft: (accidentData: FormikAccidentData) => void;
  resetDraft: () => void;
}

export const useDraftCAIStore = create<DraftCAIState>()(
  persist(
    (set, get) => ({
      draft: defaultDraftCAIFormikValues,
      setDraft: (draft) => set({ draft }),
      setVehcileAPlate: (plate: string) => {
        const currentDraft = get().draft;

        set({
          draft: {
            ...currentDraft,
            vehicleA: {
              ...currentDraft.vehicleA,
              vehicleInfo: {
                ...currentDraft.vehicleA.vehicleInfo,
                plate: plate,
              },
            },
          },
        });
      },
      resetDraft: () => set({ draft: defaultDraftCAIFormikValues }),
      updateVehicleDraft: ({
        vehicleType,
        vehicleDraft,
      }: {
        vehicleType: VehicleType;
        vehicleDraft: FormikVehicle;
      }) => {
        const currentDraft = get().draft;

        const vehicleKey =
          vehicleType === VehicleType.VEHICLE_A ? "vehicleA" : "vehicleB";

        set({
          draft: {
            ...currentDraft,
            [vehicleKey]: vehicleDraft,
          },
        });
      },
      updateAccidentDataDraft: (accidentData: FormikAccidentData) => {
        const currentDraft = get().draft;

        set({
          draft: {
            ...currentDraft,
            accidentData,
          },
        });
      },
    }),
    {
      name: STORAGE_KEY_DRAFT_CAI,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

const STORAGE_KEY_DRAFT_ID = "draftCAIID";
interface DraftIDState {
  draftID: Optional<string>;

  setDraftID: (draftID: string) => void;
  resetDraftID: () => void;
}

export const useDraftIDStore = create<DraftIDState>()(
  persist(
    (set, get) => ({
      draftID: undefined,
      setDraftID: (draftID) => set({ draftID }),
      resetDraftID: () => set({ draftID: undefined }),
    }),
    {
      name: STORAGE_KEY_DRAFT_ID,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
